import { Box } from "@mui/material";
import SliderFkdsHorn from "assets/icons/filter/slider_fkds_horn.svg";
import React, { useEffect } from "react";
import { isMobileOnly } from "react-device-detect";
import styles from "../IsochroneDialog.module.scss";

export const SliderCaption = React.memo(
  (props: {
    captionRef: React.RefObject<HTMLDivElement | null>;
    arrowRef: React.RefObject<HTMLDivElement | null>;
    captionLeft: number | undefined;
    captionRight: number | undefined;
    arrowLeft: number | undefined;
    arrowRight: number | undefined;
    caption: string[];
    chaseThumb: () => void;
  }) => {
    const { captionRef, arrowRef } = props;

    useEffect(() => {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === captionRef.current) props.chaseThumb();
          if (entry.target === arrowRef.current) props.chaseThumb();
        }
      });

      resizeObserver.observe(captionRef.current!);
      resizeObserver.observe(arrowRef.current!);

      return () => {
        resizeObserver.disconnect();
      };
    }, [arrowRef, captionRef, props]);

    return (
      <>
        <Box className={styles.caption_box_wrapper}>
          <Box
            ref={captionRef}
            className={`${styles.caption_box1} ${
              isMobileOnly ? styles.mobileOnly : ""
            }`}
            sx={{
              left: props.captionLeft,
              right: props.captionRight
            }}
          >
            <Box className={styles.fkds_slider}>
              <span className={`${styles.value} ${styles.min}`}>
                {props.caption.at(0) ?? ""}
              </span>
              {props.caption.at(1) && <small>{props.caption.at(1)}</small>}
            </Box>
          </Box>
          <Box
            ref={arrowRef}
            className={styles.caption_box2}
            sx={{
              left: props.arrowLeft,
              right: props.arrowRight
            }}
          >
            <Box className={styles.fkds_slider_horn}>
              <img src={SliderFkdsHorn} alt="▼" />
            </Box>
          </Box>
        </Box>
      </>
    );
  }
);
